import { Client } from '@/common/services/Client';

export async function toggleLockBilling(billingUuid: string): Promise<void> {
  const response = await Client.post<void, undefined>({
    body: undefined,
    endpoint: `/billing/${billingUuid}/lock`,
  });
  return response.data;
}
